import { useState, useEffect } from 'react';
import css from './CookieBlockedIframe.module.css';

const CookieBlockedIframe = ({
  src,
  width,
  height,
  title,
  dataCookieConsent,
}) => {
  const [hasConsent, setHasConsent] = useState(false);
  const [embedUrl, setEmbedUrl] = useState('');

  useEffect(() => {
    const convertToEmbedUrl = (url) => {
      try {
        if (url.includes('/embed/')) {
          return url.replace('www.youtube.com', 'www.youtube-nocookie.com');
        }

        const regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length === 11) {
          const videoId = match[2];
          return `https://www.youtube-nocookie.com/embed/${videoId}`;
        }

        return url;
      } catch (error) {
        console.error('Error converting YouTube URL:', error);
        return url;
      }
    };

    setEmbedUrl(convertToEmbedUrl(src));
  }, [src]);

  useEffect(() => {
    if (window.Cookiebot && window.Cookiebot.consent?.marketing) {
      setHasConsent(true);
    }

    const onConsentGiven = () => {
      if (window.Cookiebot.consent?.marketing) {
        setHasConsent(true);
      }
    };
    window.addEventListener('CookiebotOnAccept', onConsentGiven);

    return () => {
      window.removeEventListener('CookiebotOnAccept', onConsentGiven);
    };
  }, []);

  if (!hasConsent) {
    return (
      <div className={css.cookieConsentPlaceholderContainer}>
        <div className={css.cookiePlaceholder}>
          <p className={css.cookiePlaceholderText}>
            Please{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.Cookiebot.renew();
              }}
            >
              accept marketing cookies
            </a>{' '}
            to view this content.
          </p>
        </div>
      </div>
    );
  }

  return (
    <iframe
      width="100%"
      height="100%"
      src={embedUrl}
      data-cookieconsent={dataCookieConsent}
      style={{ border: 'none' }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={title}
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
};

export default CookieBlockedIframe;
